export default "__VITE_ASSET__CCldaVFY__"